"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var Timer =
/*#__PURE__*/
function () {
  function Timer(callback, delay) {
    (0, _classCallCheck2["default"])(this, Timer);
    this.callback = callback;
    this.remaining = delay;
    this.resume();
  }

  (0, _createClass2["default"])(Timer, [{
    key: "pause",
    value: function pause() {
      window.clearTimeout(this.timerId);
      this.remaining -= new Date() - this.start;
    }
  }, {
    key: "resume",
    value: function resume() {
      this.start = new Date();

      if (this.timerId) {
        window.clearTimeout(this.timerId);
      }

      this.timerId = window.setTimeout(this.callback, this.remaining);
    }
  }]);
  return Timer;
}();

exports["default"] = Timer;